import { render, staticRenderFns } from "./imgDetail.vue?vue&type=template&id=d0d9333e&scoped=true&"
import script from "./imgDetail.vue?vue&type=script&lang=ts&"
export * from "./imgDetail.vue?vue&type=script&lang=ts&"
import style0 from "./imgDetail.vue?vue&type=style&index=0&id=d0d9333e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d9333e",
  null
  
)

export default component.exports